import React, { ReactNode } from 'react';
import Link from 'next/link';
import Button from '@/components/shared/Button';
import Heading from '@/components/shared/Heading';

import './styles.css';

interface LinkProps {
  label: string;
  url: string;
  ariaLabel?: string;
  target?: string;
}

interface TextBlockProps extends React.PropsWithChildren {
  mainText: string | ReactNode;
  subText?: string;
  customButtons?: ReactNode;
  mainButton?: LinkProps;
  subButton?: LinkProps;
}
export const TextBlock = ({
  mainText,
  subText,
  mainButton,
  subButton,
  customButtons,
  children
}: TextBlockProps) => (
  <div>
    {subText ? (
      <Heading variant="h4" className="mb-4 font-regular uppercase text-white" asChild>
        <p>{subText}</p>
      </Heading>
    ) : null}
    {typeof mainText === 'string' ? (
      <Heading
        variant="h3"
        display
        className="text-white lg:text-[2.5rem]/[3rem] 2xl:text-5xl/[3.5rem]"
        asChild
      >
        <h2>{mainText}</h2>
      </Heading>
    ) : (
      mainText
    )}
    {children}
    <div className="banner__buttons-cta">
      {customButtons}
      {mainButton?.url && (
        <Button className="text-white" asChild>
          <Link
            href={mainButton?.url ?? ''}
            aria-label={mainButton?.ariaLabel ?? ''}
            target={mainButton?.target ?? '_self'}
          >
            {mainButton.label}
          </Link>
        </Button>
      )}

      {subButton?.url && (
        <Button variant="light" outline className="text-white" asChild>
          <Link
            href={subButton?.url ?? ''}
            aria-label={subButton?.ariaLabel ?? ''}
            target={subButton?.target ?? '_self'}
          >
            {subButton.label}
          </Link>
        </Button>
      )}
    </div>
  </div>
);
